import {
  OtherDeductionItem,
  OtherDeductionItemType,
} from "@/models/other-deduction-items.model";
import apiClient from "./apiClient";

export async function getOtherDeductionItems(args: {
  userId: number;
  month: number;
  year: number;
}): Promise<OtherDeductionItem[]> {
  const { userId, month, year } = args;
  const res = await apiClient.get(
    `/users/${userId}/other-deduction-items?month=${month}&year=${year}`
  );
  const data: OtherDeductionItem[] = res.data as OtherDeductionItem[];
  return data;
}

export async function addHocItem(args: {
  amount: number;
  type: OtherDeductionItemType;
  payslipId?: number;
  userId?: number;
  month?: number;
  year?: number;
}): Promise<OtherDeductionItem> {
  const res = await apiClient.post("/other-deduction-items", {
    ...args,
  });
  const data: OtherDeductionItem = res.data as OtherDeductionItem;
  return data;
}

export async function deleteOtherDeductionItem(id: number): Promise<boolean> {
  const res = await apiClient.delete(`/other-deduction-items/${id}`);
  return res.data as boolean;
}
